module.exports = __webpack_public_path__ + "img/trio-page-4-silken.43d13b58.jpg";